import { Chip, Paper, Typography } from "@mui/material";
import SmartAvatar from "../Avatar/SmartAvatar";
import ReferralListSkeleton from "./ReferralListSkeleton"; // your minimal skeleton

// --- helpers
function normalizeStatus(s = "") {
  const x = s.toLowerCase();
  if (x === "accepted") return "Accepted";
  if (x === "invited") return "Invited";
  return s || "";
}

function toDisplay(row = {}) {
  const badge = normalizeStatus(row.status || "");
  const isInvited = badge === "Invited";
  const isAccepted = badge === "Accepted";
  const TotalEarnings = row.referredTotal != 0 ? `Earned ₹ ${row.referredTotal}` : null;
  // const TotalMilestones = 10;
    const lastRange =
    Array.isArray(row.ReferralTransaction) && row.ReferralTransaction.length > 0
      ? row.ReferralTransaction[row.ReferralTransaction.length - 1].range || 0
      : 0;

  const TotalMilestones = lastRange;

  const title = isInvited
    ? (row.email || "invite@example.com")
    : (row.DoctorName || row.name || "—");

  return {
    id: row._id ?? "",
    badge,
    isInvited,
    isAccepted,
    title,
    TotalEarnings,
    TotalMilestones,
    avatar: {
      // accepted -> show image if available; else initials from name
      // invited  -> initials from email
      src: isAccepted ? (row.coverPic || row.profile || "") : "",
      name: isAccepted ? (row.DoctorName || row.name || "") : "",
      email: isInvited ? (row.email || "") : "",
    },
    raw: row,
  };
}

/**
 * Props:
 * - list: array
 * - loading?: boolean
 * - onOpenReferral?: (row) => void  // fires only for Accepted rows
 * - emptyText?: string
 */
export default function ReferralList({
  list = [],
  loading = false,
  onOpenReferral,
  emptyText = "No referrals yet",
}) {
  if (loading) return <ReferralListSkeleton count={5} />;

  const items = (Array.isArray(list) ? list : []).map(toDisplay);
  if (!items.length) {
    return (
      <Paper sx={{ p: 2, borderRadius: 2, border: "1px solid #eee" }}>
        <Typography variant="body2" color="text.secondary">{emptyText}</Typography>
      </Paper>
    );
  }

  return (
    <div style={{ maxHeight: 440, overflowY: "auto" }}>
      {items.map((it, idx) => {
        const clickable = it.isAccepted && typeof onOpenReferral === "function";
        return (
          <div key={it.id || `ref-${idx}`}>
            <div
              className={`flex items-center gap-3 px-3 py-3 ${clickable ? "cursor-pointer hover:bg-gray-50" : ""
                }`}
              onClick={() => {
                if (clickable) onOpenReferral(it.raw);
              }}
            >
              {/* avatar */}
              <SmartAvatar
                src={`${process.env.REACT_APP_API_URL}/${it.avatar.src}`}
                name={it.avatar.name}
                email={it.avatar.email}
                size={44}
              />

              {/* text (single line) */}
              <div className="flex-1 min-w-0">
                <Typography
                  variant="body1"
                  fontWeight={700}
                  noWrap
                  title={it.title}
                  className="text-gray-900"
                >
                  {it.title}
                </Typography>
                {
                  it.TotalMilestones && <p className="text-xs text-gray-500 font-light">
                    Milestone : {it.TotalMilestones}
                  </p>
                }


              </div>

              {/* right badge */}
              {/* <Chip
                  label={it.badge}
                  size="small"
                  sx={{
                    borderRadius: "10px",
                    paddingLeft: "14px",
                    paddingRight: "14px",
                    fontWeight: 600,
                    backgroundColor: it.isAccepted
                      ? "rgb(45 129 220 / 12%)"      // green-ish
                      : "rgba(245,158,11,0.12)",    // amber-ish
                    color: it.isAccepted ? "#054ba7" : "#92400E",
                    height: 34,
                  }}
                /> */}
              {
                it.TotalEarnings != null &&
                <Chip
                  label={it.TotalEarnings}
                  size="small"
                  sx={{
                    borderRadius: "10px",
                    paddingLeft: "14px",
                    paddingRight: "14px",
                    fontWeight: 600,
                    backgroundColor: "rgba(34,197,94,0.12)",
                    color: "#166534",
                    height: 30,
                    marginTop: "4px"
                  }}
                />
              }
            </div>

            {/* divider */}
            {idx < items.length - 1 && (
              <div className="h-px w-full bg-gray-200/80" />
            )}
          </div>
        );
      })}
    </div>

  );
}
